import { createSlice } from '@reduxjs/toolkit';

import type { Notification } from './types';

export const slice = createSlice({
    initialState: {
        toast: null as Notification | null
    },

    name: 'useToast',

    reducers: {
        toast: (state, action) => {
            state.toast = action.payload;
        }
    }
});

export default slice.reducer;
